import { TICK2TRADE_PROVIDER, type BackendProvider, type ProviderCapabilities, type ProviderLogin } from '../adapters/types'
import { getRegisteredProvider } from '../providers/registry'

/** The backend this build talks to (VITE_BACKEND_PROVIDER). */
export const currentBackendProvider = (): BackendProvider =>
    import.meta.env.VITE_BACKEND_PROVIDER || TICK2TRADE_PROVIDER

const resolveCapabilities = (): ProviderCapabilities => {
    const definition = getRegisteredProvider(currentBackendProvider()) ?? getRegisteredProvider(TICK2TRADE_PROVIDER)
    if (!definition) {
        // Providers register when `providers/index` is imported (the axios client does that at startup).
        throw new Error('[Adapters] providerCapabilities read before any backend provider was registered')
    }
    return definition.capabilities
}

/**
 * What this build's backend offers. UI code branches on these flags, never on the provider's name, so a new
 * backend only needs a registered ProviderDefinition (see providers/index).
 * Resolved on each read rather than at import: this module must not import the provider modules itself,
 * because they import the axios client, which imports them.
 */
export const providerCapabilities: ProviderCapabilities = new Proxy({} as ProviderCapabilities, {
    get: (_target, key) => resolveCapabilities()[key as keyof ProviderCapabilities],
})

/** The current backend's provider-side OAuth login, if it has one. */
export const providerLogin = (): ProviderLogin | undefined => getRegisteredProvider(currentBackendProvider())?.login

export const isAutoLoginEnabled = (): boolean =>
    import.meta.env.VITE_AUTO_LOGIN_ENABLED === 'true'
